import { TEMP_DIRECT_LINK } from 'Shared/constants';

const setDirectLink = (): void => {
    if (!['', '/login'].includes(window.location.pathname)) {
        const queryString = window.location.search || '';
        sessionStorage.setItem(TEMP_DIRECT_LINK, window.location.pathname + queryString);
    }
};

export default setDirectLink;
